var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container-data-input-card',{attrs:{"value":_vm.orgData,"config":_vm.config,"blocked":_vm.block,"is-single":"","can-close-enter":"","spr-data":_vm.sprList,"saving":_vm.loading,"error":_vm.error,"appealStatus":_vm.appealStatus},on:{"change-data":function($event){return _vm.sendAppeal($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }